// Constants
import { CompanyName } from '../Constants';
// Small Gallery Images
import Image1 from '../../assets/images/smallGallery/miss-dominatrixa-elite-dominatrix-in-cat-suit-small.webp';
import Image2 from '../../assets/images/smallGallery/miss-dominatrixa-elite-dominatrix-with-adult-baby.webp';
import Image3 from '../../assets/images/smallGallery/miss-dominatrixa-elite-dominatrix-with-strap-on-dildo-small.webp';
import Image4 from '../../assets/images/smallGallery/miss-dominatrixa-dungeon-image-punishment-chair-small.webp';
import Image5 from '../../assets/images/smallGallery/miss-dominatrixa-elite-dominatrix-main-fur-coat-small.webp';
import Image6 from '../../assets/images/smallGallery/miss-dominatrixa-elite-dominatrix-hot-anal.jpg';
import Image7 from '../../assets/images/smallGallery/miss-dominatrixa-elite-dominatrixa-toy-collection-small.webp';
import Image8 from '../../assets/images/smallGallery/miss-dominatrixa-elite-dominatrix-with-whip-small.webp';

// Gallery Images
import GalleryImage1 from '../../assets/images/main/miss-dominatrixa-elite-dominatrix-main-fur-coat.webp';
import GalleryImage2 from '../../assets/images/main/miss-dominatrixa-elite-dominatrix-in-cat-suit.webp';
import GalleryImage4 from '../../assets/images/main/miss-dominatrixa-elite-dominatrixa-toy-collection.webp';
import GalleryImage3 from '../../assets/images/main/miss-dominatrixa-pro-domme-bed-with-toys.webp';
import GalleryImage5 from '../../assets/images/main/miss-dominatrixa-elite-dominatrix-nude-in-chair.webp';
import GalleryImage6 from '../../assets/images/main/miss-dominatrixa-pro-domme-boots.webp';
import GalleryImage7 from '../../assets/images/main/miss-dominatrixa-elite-dominatrix-with-masked-slave.webp';
import GalleryImage8 from '../../assets/images/main/miss-dominatrixa-elite-dominatrix-with-strap-on-dildo.webp';
import GalleryImage9 from '../../assets/images/main/miss-dominatrixa-elite-dominatrix-with-whip.webp';
import GalleryImage10 from '../../assets/images/main/miss-dominatrixa-elite-dominatrix-sub-and-dildo.webp';
import GalleryImage11 from '../../assets/images/main/miss-dominatrixa-pro-domme-chained-up-sub.webp';
import GalleryImage12 from '../../assets/images/main/miss-dominatrixa-elite-dominatrix-hot-anal.webp';
import GalleryImage13 from '../../assets/images/main/miss-dominatrixa-elite-dominatrix-black-sexy-outfit.webp';
import GalleryImage14 from '../../assets/images/main/miss-dominatrixa-elite-dominatrix-in-fishnets.webp';
import GalleryImage15 from '../../assets/images/main/miss-dominatrixa-elite-dominatrix-with-adult-baby.webp';
import GalleryImage16 from '../../assets/images/main/miss-dominatrixa-elite-dominatrix-sub-under-heel.webp';
import GalleryImage17 from '../../assets/images/main/miss-dominatrixa-pro-domme-spanking-sub.webp';

let glId = 1;
// Image Data Array
export const smallGalleryImagesArray = [
  {
    id: glId++,
    src: Image1,
    name: 'Sofa Elegance',
    alt: `${CompanyName} exuding elegance on a luxurious sofa`,
    ariaLabel: 'Gallery image 2',
  },
  {
    id: glId++,
    src: Image2,
    name: 'Maryland Mistress',
    alt: `${CompanyName} in a commanding pose in Maryland`,
    ariaLabel: 'Gallery image 3',
  },
  {
    id: glId++,
    src: Image3,
    name: 'USA Domination',
    alt: `${CompanyName} asserting her presence across the USA`,
    ariaLabel: 'Gallery image 4',
  },
  {
    id: glId++,
    src: Image4,
    name: 'Artistic Nude',
    alt: `${CompanyName} in an intimate, semi-nude artistic pose`,
    ariaLabel: 'Gallery image 5',
  },
  {
    id: glId++,
    src: Image5,
    name: 'Sensual Power',
    alt: `${CompanyName} revealing her sensual yet dominant aura`,
    ariaLabel: 'Gallery image 6',
  },
  {
    id: glId++,
    src: Image6,
    name: 'Sultry Command',
    alt: `${CompanyName} striking a seductive yet commanding pose`,
    ariaLabel: 'Gallery image 7',
  },
  {
    id: glId++,
    src: Image7,
    name: 'Tattooed Temptation',
    alt: `${CompanyName} showcasing her striking tattoos with confidence`,
    ariaLabel: 'Gallery image 8',
  },
  {
    id: glId++,
    src: Image8,
    name: 'Tattooed Temptation',
    alt: `${CompanyName} showcasing her striking tattoos with confidence`,
    ariaLabel: 'Gallery image 8',
  },
];

let galleryId = 1;
export const galleryImagesArray = [
  {
    src: GalleryImage10,
    alt: `${CompanyName} - After Dark`,
    name: 'After Dark',
    date: 'February 1, 2025',
  },
  {
    src: GalleryImage11,
    alt: `${CompanyName} - Crimson Heat`,
    name: 'Crimson Heat',
    date: 'February 1, 2025',
  },
  {
    src: GalleryImage12,
    alt: `${CompanyName} - Velvet Sin`,
    name: 'Velvet Sin',
    date: 'February 1, 2025',
  },
  {
    src: GalleryImage13,
    alt: `${CompanyName} - Night Out`,
    name: 'Night Out',
    date: 'February 1, 2025',
  },
  {
    src: GalleryImage1,
    alt: `${CompanyName} - Night Out`,
    name: 'Night Out',
    date: 'February 1, 2025',
  },
  {
    src: GalleryImage2,
    alt: `${CompanyName} - Sensual Seduction`,
    name: 'Sensual Seduction',
    date: 'February 2, 2025',
  },
  {
    src: GalleryImage3,
    alt: `${CompanyName} - Midnight Desire`,
    name: 'Midnight Desire',
    date: 'February 3, 2025',
  },
  {
    src: GalleryImage4,
    alt: `${CompanyName} - Sub Rest`,
    name: 'Sub Rest',
    date: 'February 4, 2025',
  },
  {
    src: GalleryImage5,
    alt: `${CompanyName} - Chastity & Heels`,
    name: 'Chastity & Heels',
    date: 'February 5, 2025',
  },
  {
    src: GalleryImage6,
    alt: `${CompanyName} - Dark Temptation`,
    name: 'Dark Temptation',
    date: 'February 6, 2025',
  },
  {
    src: GalleryImage7,
    alt: `${CompanyName} - Sissy Obsession`,
    name: 'Sissy Obsession',
    date: 'February 7, 2025',
  },
  {
    src: GalleryImage8,
    alt: `${CompanyName} - Forbidden Pleasures`,
    name: 'Forbidden Pleasures',
    date: 'February 8, 2025',
  },
  {
    src: GalleryImage9,
    alt: `${CompanyName} - Seductive Stare`,
    name: 'Seductive Stare',
    date: 'February 9, 2025',
  },
  {
    src: GalleryImage17,
    alt: `${CompanyName} - Midnight Allure`,
    name: 'Midnight Allure',
    date: 'February 9, 2025',
  },
  {
    src: GalleryImage16,
    alt: `${CompanyName} - Crimson Desire`,
    name: 'Crimson Desire',
    date: 'February 9, 2025',
  },
  {
    src: GalleryImage15,
    alt: `${CompanyName} - Velvet Temptation`,
    name: 'Velvet Temptation',
    date: 'February 9, 2025',
  },
  {
    src: GalleryImage14,
    alt: `${CompanyName} - Golden Gaze`,
    name: 'Golden Gaze',
    date: 'February 9, 2025',
  },
];
